import { createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4bd634d6")

_pushScopeId("data-v-4bd634d6")
const _hoisted_1 = { class: "user__add" }
const _hoisted_2 = { class: "add__title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-plus-circled" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Ajouter un usager", -1)
const _hoisted_5 = { class: "add__content" }
const _hoisted_6 = { class: "add__info" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "Nom: ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Courriel: ", -1)
const _hoisted_9 = { class: "add__permissions" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Rôle: ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "Équipe: ", -1)
const _hoisted_12 = { class: "permissions__wrapper" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "Grouper par équipe:", -1)
const _hoisted_14 = {
  key: 0,
  class: "listState"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "Loading...", -1)
const _hoisted_17 = {
  key: 1,
  class: "listState"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "Aucun utilisateur enregistré", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_UserCard = _resolveComponent("UserCard")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: ["button button--action", {'button--disabled': !_ctx.userAddValid}],
          tabindex: "0",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addUser && _ctx.addUser(...args)), ["enter"])),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addUser && _ctx.addUser(...args)))
        }, [
          _hoisted_3
        ], 34),
        _hoisted_4
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("img", { src: _ctx.addUserImg }, null, 8, ["src"]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", null, [
            _hoisted_7,
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addUserName = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.addUserName]
            ])
          ]),
          _createVNode("div", null, [
            _hoisted_8,
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addUserEmail = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.addUserEmail]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", null, [
            _hoisted_10,
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.addUserRole = $event))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userRoles, (rolename) => {
                return (_openBlock(), _createBlock("option", { key: rolename }, _toDisplayString(rolename), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.addUserRole]
            ])
          ]),
          _createVNode("div", null, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.addUserTeams, (team, ix) => {
                return _withDirectives((_openBlock(), _createBlock("select", {
                  key: ix,
                  "onUpdate:modelValue": ($event: any) => (_ctx.addUserTeams[ix] = $event)
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedTeams, (team, ix) => {
                    return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                  }), 128))
                ], 8, ["onUpdate:modelValue"])), [
                  [_vModelSelect, _ctx.addUserTeams[ix]]
                ])
              }), 128)),
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.addUserTeams[_ctx.addUserTeams.length] = $event))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedTeams, (team, ix) => {
                  return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.addUserTeams[_ctx.addUserTeams.length]]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", {
      class: "user__sort",
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleGroupByTeam && _ctx.toggleGroupByTeam(...args)))
    }, [
      _hoisted_13,
      _createVNode("i", {
        class: {
                'icon-enabled':_ctx.userByTeams,
                'icon-disabled':!_ctx.userByTeams,
            }
      }, null, 2)
    ]),
    (_ctx.userLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_14, [
          _hoisted_15,
          _hoisted_16
        ]))
      : (_ctx.userReady && !_ctx.users.length)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19
          ]))
        : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedUserKeys, (k) => {
      return (_openBlock(), _createBlock("div", { key: k }, [
        _createVNode("div", {
          class: "user-table__title",
          onClick: ($event: any) => (_ctx.toggleUserGroup(k))
        }, [
          (!_ctx.userByTeams || k === _ctx.NO_TEAMS)
            ? (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(_ctx.roleDisplayName(k)), 1))
            : (_openBlock(), _createBlock(_component_TeamLabel, {
                key: 1,
                team: _ctx.getTeam(k),
                link: false
              }, null, 8, ["team"])),
          _createVNode("i", {
            class: {
                'icon-angle-down':_ctx.isUserGroupShown(k),
                'icon-angle-right':!_ctx.isUserGroupShown(k)
              }
          }, null, 2)
        ], 8, ["onClick"]),
        (_ctx.isUserGroupShown(k))
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedUsers[k], (user) => {
                return (_openBlock(), _createBlock(_component_UserCard, {
                  key: user._id,
                  user: user,
                  canDelete: !_ctx.isSelf(user._id),
                  canEditRole: !_ctx.isSelf(user._id),
                  onUserDelete: _ctx.deleteUser,
                  onUserEdit: _ctx.editUser
                }, null, 8, ["user", "canDelete", "canEditRole", "onUserDelete", "onUserEdit"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
})